import React from 'react'
import WaveformCanvas from './WaveformCanvas'
import { T, Label, Hr, speakerColor } from './SharedLayout'
import InlineAudioPlayer from './InlineAudioPlayer'
import CombinedPlayer from './CombinedPlayer'

const DualTrackSection = ({
  scene,
  isPlaying,
  onPlayingChange,
  onPlayheadChange
}) => {
  const hasNar = Boolean(scene?.narration_audio_link)
  const hasDia = Boolean(scene?.dialogue_audio_link)

  if (!hasNar && !hasDia) return null

  return (
    <section style={{ marginBottom: 24 }}>
      <Label>Scene Audio (Dual Track)</Label>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {/* Narration Track */}
        {hasNar && (
          <div
            className="audio-track-container"
            style={{ position: 'relative' }}
          >
            <InlineAudioPlayer
              src={scene.narration_audio_link}
              label="Narration Track"
              accent={T.blue}
            />
            <div style={{ marginTop: 8, padding: '0 4px' }}>
              <WaveformCanvas
                audioUrl={scene.narration_audio_link}
                color={T.blue}
                height={32}
              />
            </div>
          </div>
        )}

        {/* Dialogue Track */}
        {hasDia && (
          <div
            className="audio-track-container"
            style={{ position: 'relative' }}
          >
            <InlineAudioPlayer
              src={scene.dialogue_audio_link}
              label="Dialogue Track"
              accent={T.amber}
            />
            <div style={{ marginTop: 8, padding: '0 4px' }}>
              <WaveformCanvas
                audioUrl={scene.dialogue_audio_link}
                color={T.amber}
                height={32}
              />
            </div>
          </div>
        )}

        {/* Combined Playback Control */}
        {hasNar && hasDia && (
          <CombinedPlayer
            narrationSrc={scene.narration_audio_link}
            dialogueSrc={scene.dialogue_audio_link}
            duration={scene.audio_duration}
            isPlaying={isPlaying}
            onPlayingChange={onPlayingChange}
            onPlayheadChange={onPlayheadChange}
          />
        )}
      </div>
    </section>
  )
}

export default DualTrackSection
